import React, { useContext } from 'react';
import classNames from 'classnames/bind';
import proptypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useImpression } from '@thd-olt-component-react/impression';
import {
  params,
  customType,
  fragment,
  shape as shapeType,
  string as stringType,
  bool as boolType,
  useDataModel, QueryProvider, extend
} from '@thd-nucleus/data-sources';
import { useHelmet } from '@thd-nucleus/thd-helmet';
import styles from '../SponsoredBanner/SponsoredBanner.module.scss';
import { getDefaultBanner, shouldSkipDataModel, preloadDefaultBanner } from '../../utils/helpers';

const { object, string } = proptypes;

const DefaultBannerComponent = ({
  contentfulDefaultBanner,
  schema,
  shouldPreload,
  shouldSuppress
}) => {
  const experienceContext = useContext(ExperienceContext);
  let cx = classNames.bind(styles);
  const skip = shouldSkipDataModel(schema);
  const resp = useDataModel('container', {
    skip,
    variables: {
      context: {
        id: '4OH5iatZ0vFnTL58Qg8eJv'
      }
    }
  });

  const { data: defaultBanner } = resp;
  const validatedDefaultBanner = defaultBanner?.container || contentfulDefaultBanner;

  const defaultBannerInfo = getDefaultBanner(experienceContext, validatedDefaultBanner);
  const data = {
    shouldPreload,
    defaultBannerInfo,
    shouldSuppress
  }

  useHelmet('preloadBanner', { data }, preloadDefaultBanner);

  const { ref, clickID } = useImpression({
    data: {
      id: '00DEFVALSPB00',
      name: 'defaultbanner',
      component: 'SponsoredUniversalBanner',
      type: 'content',
      position: 1,
    }
  });
  return (
    <div
      ref={ref}
      // eslint-disable-next-line react/no-unknown-property
      clickid={clickID}
      id="default_banner_carousel"
      style={defaultBannerInfo.spacingCss}
      data-testid="default-standard-banner"
    >
      <a href={defaultBannerInfo.href}>
        {/* eslint-disable-next-line */}
        <img
          className={cx('sponsored_banner_image')}
          alt="sponsored banner"
          src={defaultBannerInfo.imgSrc}
        />
      </a>
    </div>
  );
};

const propTypes = {
  contentfulDefaultBanner: object,
  schema: string,
  shouldPreload: proptypes.bool,
  shouldSuppress: proptypes.bool
};

const defaultProps = {
  contentfulDefaultBanner: {},
  schema: '',
  shouldPreload: true,
  shouldSuppress: false
};

DefaultBannerComponent.propTypes = propTypes;
DefaultBannerComponent.defaultProps = defaultProps;
DefaultBannerComponent.dataModel = {
  container: params({
    context: customType('QueryContext')
      .shape({
        id: stringType()
      })
  })
    .shape({
      SponsoredTopBanner: fragment()
        .shape({
          imgDesktop: stringType(),
          imgMobile: stringType(),
          clickthruUrl: stringType(),
          specialDefaultBanner: shapeType({
            imgDesktop: stringType(),
            imgMobile: stringType(),
            clickthruUrl: stringType(),
            useSpecialBanner: boolType()
          })
        }),
    }),
};

const DefaultBanner = (props) => {

  const skipFn = ({ skip, queryName }) => {
    return skip;
  };

  return (
    <QueryProvider cacheKey="default-banner" skip={skipFn}>
      <DefaultBannerComponent {...props} />
    </QueryProvider>
  );
};
DefaultBanner.propTypes = propTypes;

DefaultBanner.defaultProps = defaultProps;
DefaultBanner.dataModel = extend({}, DefaultBannerComponent);

export { DefaultBanner };
